import { html } from '@shared/utils/rendering/html';
import Button from '@shared/components/buttons';
import { Icon } from '@shared/components/icons';

const handleGoHome = () => {
    window.location.href = '/';
};
const handleReload = () => window.location.reload();

const OfflineScreen = ({ systemName, message, estimatedReturn }) => {
    const formatDateTime = (dateString) => {
        if (!dateString) return null;
        try {
            const date = new Date(dateString);
            return date.toLocaleString('en-ZA', {
                dateStyle: 'medium',
                timeStyle: 'short',
            });
        } catch {
            return null;
        }
    };

    const formattedEta = formatDateTime(estimatedReturn);

    return html`<div class="offline-screen">
        <div class="offline-screen__content">
            <div class="offline-screen__icon">
                <${Icon} name="engineering" />
            </div>
            <div class="offline-screen__message">
                <h3 class="offline-screen__title">
                    ${systemName || 'System'} is Currently Offline
                </h3>
                <p class="offline-screen__subtitle">
                    ${
                        message ||
                        'This system is temporarily unavailable for maintenance. We apologize for the inconvenience.'
                    }
                </p>
                ${
                    formattedEta
                        ? html`<p class="offline-screen__eta">
                              <strong>Expected back:</strong> ${formattedEta}
                          </p>`
                        : null
                }
            </div>
            <div class="offline-screen__actions">
                <${Button}
                    buttonType="secondary"
                    css="offline-screen__action"
                    label=${{ text: 'Return to Home' }}
                    onClick=${handleGoHome}
                />
                <${Button}
                    buttonType="secondary"
                    css="offline-screen__action"
                    label=${{ text: 'Refresh Page' }}
                    onClick=${handleReload}
                />
            </div>
        </div>
    </div>`;
};

export default OfflineScreen;
